import Vue from 'vue';
import axios from 'axios';
import Raven from 'raven-js';

const API_BASE = 'https://secure-lake-56444.herokuapp.com/api/v1';
//const API_BASE = 'http://localhost:5000/api/v1';

/* global localStorage */
const base = axios.create({
  baseURL: `${API_BASE}/`,
  headers: {
    'Content-Type': 'application/json',
  }
});

const openErrorMessage = (msg) => {
  Vue.prototype.$toast.open({
    duration: 5000,
    message: msg,
    position: 'is-top',
    type: 'is-danger'
  })
};

const api = {
  handleError (error) {
    let status = error.response ? error.response.status : null;

    switch (status) {
      case 404:
        openErrorMessage("Oops, something went wrong! We may have some problems with our server...");
        break;

      case 429:
        openErrorMessage("Whoa there, slow down! If you need access to the raw data you can download it from GitHub.");
        break;

      default:
        openErrorMessage("Oops, something went wrong! We may have some problems with our server...");

        Raven.captureException(error);
        console.error(error.message);
        break;
    }
  },

  postAuth (params) {
    let headers = {
      'Content-Type': 'application/json',
    };

    return base.post('auth',
      params,
      {
        headers: headers
      });
  },

  postResponse (params) {
    let headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.token}`,
    };

    return base.post('response',
      params,
      {
        headers: headers
      });
  },
};

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js